import {UIType} from "./@const";
import {UITeams} from "./teams/teams";
import {GoodDayUserInterface} from "./ui";
import {UIAsana} from "./asana/asana";
import {GoodDayTop} from "./classic/goodday-top";
import {GoodDayLeft} from "./classic/goodday-left";
import {GoodDayModern} from "./modern/goodday-modern";

export function createUI(type: UIType):GoodDayUserInterface {

    // console.log("UI factory type=", type)

    switch (type) {
        case UIType.CLICK_UP:
        case UIType.GOODDAY_MODERN:
            return new GoodDayModern();

        // case UIType.CLICK_UP:
        //     return new UIClickup()

        case UIType.TEAMS:
            return new UITeams()

        case UIType.ASANA:
            return new UIAsana()

        case UIType.LEFT:
            return new GoodDayLeft()

        case UIType.TOP:
            return new GoodDayTop()

        default:
            console.error("createUI() unknown type=", type)
            // return new UIClickup()
            return new GoodDayModern()

    }


}
